import { action, makeObservable, observable, autorun, computed } from 'mobx';
import { AccountingStatementService } from '../services';
import { BalanceInformationNodeModel } from '../models';
import { SettingsUtils } from '../../custom_shared/misc';
import { BusinessSearchStoreBase, SourceStore } from '../../custom_shared/stores';
import AppStore from './AppStore';
import SessionStore from './SessionStore';

export default class BusinessSearchStore extends BusinessSearchStoreBase {
    balanceInformationNode: BalanceInformationNodeModel | null = null;

    constructor(
        readonly appStore: AppStore,
        readonly sessionStore: SessionStore,
        readonly sourceStore: SourceStore,
        readonly service: AccountingStatementService
    ) {
        super(appStore, sourceStore, service);

        makeObservable(this, {
            balanceInformationNode: observable,
            setBalanceInformationNode: action,
            isBusinessSearchSupported: computed
        });

        this.reactions.push(
            autorun(r => {
                if (this.sessionStore.isInitializing || !this.isBusinessSearchSupported) {
                    return;
                }

                this.getBusinessPartners();
                r.dispose();
            })
        );
    }

    get isBusinessSearchSupported() {
        return SettingsUtils.ensureSqlScriptIdsConfigured(this.sessionStore.settings, this.sqlScriptIds);
    }

    setBalanceInformationNode(balanceInformationNode: BalanceInformationNodeModel | null) {
        this.balanceInformationNode = balanceInformationNode;
    }

    initializeSearchModal(balanceInformationNode: BalanceInformationNodeModel) {
        this.setBalanceInformationNode(balanceInformationNode);
        this.setModalVisible(true);
    }
}
